import { Location } from '@angular/common'
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

import { SearchBy } from '../../enums/enums'
import { GlobalSearchService } from '../../services/global-search.service'
import { I18nService, LgType } from '../../services/prod/i18n.service'
import { ProducerSearchItemType } from '../../types/producer.type'

@Component({
  selector: 'bmcore-producers-block',
  templateUrl: './bmcore-producers-block.component.html',
  styleUrls: ['./bmcore-producers-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreProducersBlockComponent implements OnInit {
  lg: LgType
  producerNameSearch = ''
  producers: ProducerSearchItemType[] = []
  showNoProducersMessage = false

  constructor(
    private globalSearchService: GlobalSearchService,
    private location: Location,
    private i18nService: I18nService
  ) {
    this.lg = this.i18nService.getLanguageForPage()
  }

  ngOnInit(): void {
    this.location.replaceState('/catalog')
    this.getProducers()
  }

  getProducers() {
    this.globalSearchService.getData(SearchBy.Beatmakers, this.producerNameSearch).subscribe(res => {
      if (res.length) {
        this.showNoProducersMessage = false
        this.producers = res as ProducerSearchItemType[]
      } else {
        this.showNoProducersMessage = true
        this.producers = []
      }
    })
  }

  searchHandler(e: Event) {
    this.producerNameSearch = (e.currentTarget as HTMLInputElement).value
  }
}
